var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xl:w-4/5 md:w-11/12 xl:my-10 md:my-4 md:mx-auto m-1 bg-gray-50 rounded"},[_c('h1',{staticClass:"font-semibold xl:text-xl text-center p-4"},[_vm._v("Requests History")]),_vm._v(" "),_c('Table',{attrs:{"items":_vm.items,"getTheDataInParent":_vm.getData,"readOnly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }